<template>
    <div class="trannsactions">

        <pageheader text="Transaksjoner"/>

        <p>
            Her kan du se alle din transaksjoner til og fra spillekontoen din gjort hos Norskbingo.no
        </p>



        <b-table striped hover :busy="isBusy" :items="transactions" :fields="fields" :tbody-tr-class="rowClass">

            <template v-slot:cell(value)="data">
                {{ data.value  }},-
            </template>

            <template v-slot:table-busy>
                <div class="text-center  my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Laster...</strong>
                </div>
            </template>


        </b-table>

    </div>
</template>

<script>
// @ is an alias to /src


export default {
    name: 'Transactions',
    components: {

    },
    data() {
        return {
            transactions: [],
            isBusy: true,
            fields: [
                {
                    key:'date',
                    label:"Dato"
                },
                {
                    key:'value',
                    label:"Verdi"
                },
                {
                    key:'reason',
                    label:"Beskrivelse"
                }
            ]
        }
    },
    mounted() {


        this.$api.get(`/users/${this.$store.getUser().card_id}/transactions/`)
        .then((response) => {


            this.transactions = response.data.data.map( x => {
                let d = new Date(x.date);
                x.date = d.getDate()+'/' + (d.getMonth()+1) + '/'+d.getFullYear();
                return x;
            });
            this.isBusy = false;

        })
        .catch((response) => {
            console.log(response);
        });


    },
    methods: {
        rowClass(item, type) {
            if (!item) return
            if (item.value > 0) return 'value-positive'
            else if (item.value < 0) return 'value-negative'
        }
    }
}
</script>


<style lang="scss">

.value-positive td:nth-of-type(2) {
    color:green;
}
.value-negative td:nth-of-type(2) {
    color:red;
}


</style>
